import React from 'react';
import { BsFiletypeCsv, BsFiletypeJson } from 'react-icons/bs';

import { Icon } from '@/components/icon/icon';

import styles from '../../contractDetails.module.scss';
import { generateSampleData } from '../../utils/generateSampleData';

interface ModelField {
  type?: string;
}

interface Model {
  fields?: Record<string, ModelField>;
}

interface ModelExamplesTabProps {
  models: Record<string, Model>;
}

export function ModelExamplesTab( { models }: ModelExamplesTabProps ) {
  return (
    <div className={ styles.tabPanel } data-testid='panel-model-examples'>
      { Object.entries( models ).map( ( [ modelName, model ] ) => {
        // Determine file type icon based on model type or name
        const FileIcon = modelName.includes( 'json' ) ? BsFiletypeJson : BsFiletypeCsv;

        // Generate sample data based on fields
        const sampleData = model.fields ? generateSampleData( model.fields ) : null;

        return (
          <div key={ modelName } className={ styles.modelExampleSection }>
            <div className={ styles.modelExampleHeader }>
              <Icon icon={ FileIcon } size="md" />
              <h4 className={ styles.modelExampleTitle }>Example of { modelName }</h4>
            </div>
            { sampleData ? (
              <div className={ styles.exampleDataBox }>
                <pre className={ styles.exampleDataContent }>
                  { JSON.stringify( sampleData, null, 2 ) }
                </pre>
              </div>
            ) : (
              <div className={ styles.exampleDataBox }>
                <p className={ styles.noExamples }>No field definitions available for this model.</p>
              </div>
            ) }
          </div>
        );
      } ) }
    </div>
  );
}
